import { useEffect, useLayoutEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet, useNavigate } from 'react-router-dom'
import WebApp from '@twa-dev/sdk'
import { init } from '@amplitude/analytics-browser'

import { useApp } from 'utils'
import { PageSpinner } from 'components'
import { BabySettingsStore } from 'stores'
import { analyticsContext, ValueContext } from 'contexts'
import { AMPLITUDE_API_KEY } from 'consts'

import './styles.scss'

const isTouchable = 'ontouchstart' in window || navigator.maxTouchPoints > 0

const AppLayout = observer(() => {
  const { initialized, initDataUnsafe } = useApp()
  const [babyStore] = useState(() => new BabySettingsStore())
  const navigate = useNavigate()
  const { getBabies } = babyStore

  const startApp = WebApp.initDataUnsafe.start_param || ''

  useEffect(() => {
    switch (startApp) {
      case 'bot':
        analyticsContext.trackEvent('app_launched_via_bot')
        break
      case 'food':
        analyticsContext.trackEvent('app_launched_via_notification', { value: 'FEED' })
        break
      case 'sleep':
        analyticsContext.trackEvent('app_launched_via_notification', { value: 'SLEEP' })
        break
      default:
        if (startApp) {
          analyticsContext.trackEvent('app_launched_via_campaign', { value: startApp })
        }
        break
    }
  }, [startApp, navigate])

  useEffect(() => {
    if (isTouchable) {
      WebApp.requestFullscreen()
      document.body.classList.add('touchable')
    } else {
      WebApp.expand()
    }
    WebApp.setHeaderColor('#fff')
    WebApp.setBackgroundColor('#fff')
    document.documentElement.style.setProperty('color-scheme', 'light only')
  }, [])

  useEffect(() => {
    const requestNotifications = () => {
      try {
        WebApp.requestWriteAccess()
      } catch (e) {}
    }

    requestNotifications()
  }, [])

  useEffect(() => {
    init(AMPLITUDE_API_KEY, initDataUnsafe?.user?.id, {
      autocapture: {
        sessions: true,
        pageViews: false,
        attribution: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
      },
    })
  }, [initDataUnsafe?.user?.id])

  useEffect(() => {
    if (initialized) {
      getBabies()
    }
  }, [getBabies, initialized])

  useLayoutEffect(() => {
    if (initialized) {
      switch (startApp) {
        case 'payment-false':
        case 'payment-success':
          navigate('/chart', { state: { paymentSuccess: startApp === 'payment-success' } })
          break
      }
    }
  }, [startApp, initialized, navigate])

  return (
    <ValueContext.Provider value={babyStore}>
      <div className="full-screen">
        {initialized ? <Outlet /> : <PageSpinner delay={400} minVisibleTime={400} open opaque />}
      </div>
    </ValueContext.Provider>
  )
})

export default AppLayout
